import { useMemo } from "react";
import { useGetchoolLevels } from "../features/dashboard/courses/hooks/useGetSchoolLevels";
import { formatSchoolLevels } from "../utils/helpers";

export function useSchoolLevelOptions(selectedSchoolLevel) {
    const { data, isPending } = useGetchoolLevels();
    const formattedData = useMemo(() => formatSchoolLevels(data?.data), [data]);
    const schoolLevelOptions = useMemo(
        () =>
            formattedData?.map((item) => ({
                text: item.school_level_name,
                value: item.school_level,
            })) || [],
        [formattedData]
    );

    const gradesOptions = useMemo(() => {
        if (!selectedSchoolLevel) return [];
        return (
            formattedData?.find((item) => item.school_level === Number(selectedSchoolLevel))?.grades.map((g) => ({ text: g.label, value: g.value, id: g.id, description: g.description })) || []
        );
    }, [formattedData, selectedSchoolLevel]);

    return {
        isSchoolLevelOptionsLoading: isPending,
        schoolLevelOptions,
        gradesOptions,
    };
}
